import prospectorImg from "../../assets/prospector2.jpg";
import { FC } from "react";
import { Layout } from "../../components/Layout";
import PageHeader from "../../components/PageHeader/PageHeader";
import { PageContent } from "../../components";
import { ImageWrapper, MainContent, TextWrapper } from "./styles";

const About: FC = () => {
  return (
    <Layout>
      <PageHeader
        title="Prospector"
        description="A person who searches for valuable substance from the Word of God"
      />
      <PageContent mt={20}>
        <MainContent>
          <ImageWrapper>
            <img src={prospectorImg} alt="the prospector" />
          </ImageWrapper>
          <TextWrapper>
            Greetings! I'm Francois Mukaba, a dedicated prospector on a quest for treasures beyond measure.<br/><br/>

            Driven by a passion for wealth—not of the perishable kind, mind you, but the enduring riches bestowed by the Lord of the land—I have embarked on a journey through His vast fields, seeking precious stones of wisdom, insight, and inspiration.<br/><br/>

            Along the way, I have discovered that these treasures are not meant for hoarding, but for sharing generously with fellow prospectors and all who are intrigued by the path I tread. Each time I uncover a gem, I am reminded of the Lord’s instruction: <em>“Freely ye have received, freely give.”</em> Indeed, every good and precious stone originates from the benevolent hand of the Lord. Such treasures were never meant to lie hidden in private vaults, but to be poured out for the good of all.<br/><br/>

            My aspiration is simple: to share the bountiful treasures I have unearthed, in the hope of igniting a spark within you to explore His fields and discover even greater riches. For, as a wise prospector once said, <em>“None of us liveth to himself, and no man dieth to himself.”</em> 
            What joy it is to live in service of this King and to glean wisdom from His teachings!<br/><br/>

            So, dear friend, take up thy tools, and let us dig deep into the depths of His boundless riches—pun intended 🙂
          </TextWrapper>
        </MainContent>
      </PageContent>
    </Layout>
  );
};

export default About;
